export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Pants_Metalness.0a62c85b.tga";